/* global $ */
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';

const AttendanceSheet = () => {
    const [data, setData] = useState([]);
    const [batchNumbers, setBatchNumbers] = useState([]);
    const [selectedBatchNo, setSelectedBatchNo] = useState('');
    const [trainerName, setTrainerName] = useState([]);
    const [formData, setFormData] = useState({
        selectedTrainer1: '',
        selectedTrainer2: '',
        selectedCoordinator: '',
    });
    const [passFail, setPassFail] = useState({});

    useEffect(() => {
        const fetchTrainerName = async () => {
            try {
                const response = await axios.get('https://api.eazyworldehsengineering.com/api/trainer_name_tab');
                const unique = Array.from(
                    new Map(response.data.map(item => [item.trainer_name, item])).values()
                );
                setTrainerName(unique);
            } catch (error) {
                console.error('Error fetching trainers:', error);
            }
        };
        fetchTrainerName();
    }, []);

    useEffect(() => {
        const fetchBatchNumbers = async () => {
            try {
                const response = await axios.get('https://api.eazyworldehsengineering.com/api/batchno_tab');
                setBatchNumbers(response.data);
            } catch (error) {
                console.error('Error fetching batch numbers:', error);
            }
        };
        fetchBatchNumbers();
    }, []);

    const handleBatchChange = (e) => {
        const batchNo = e.target.value;
        setSelectedBatchNo(batchNo);
    };

    const handleViewButtonClick = async () => {
        if (!selectedBatchNo) {
            Swal.fire('Error!', 'Please select a batch number.', 'error');
            return;
        }
        try {
            const response = await axios.get(
                `https://api.eazyworldehsengineering.com/api/candidate_registration/attendance?batch_no=${selectedBatchNo}`
            );
            setData(response.data);
        } catch (error) {
            console.error('Error fetching data:', error);
            Swal.fire('Error!', 'There was an issue fetching the data.', 'error');
        }
    };

    const handleResetButtonClick = () => {
        setSelectedBatchNo('');
        setData([]);
        setPassFail({});
    };

    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handlePassFailChange = (masId, value) => {
        setPassFail(prev => ({ ...prev, [masId]: value }));
    };

    const handlePrint = () => {
        const printContent = document.querySelector('.printable-content');
        if (!printContent) return;
        // Only inject the component's own inline styles — external CSS (AdminLTE, plugins)
        // breaks the flex spacer layout and pushes the footer to the middle of the page.
        const inlineStyles = Array.from(document.querySelectorAll('style'))
            .map(s => s.outerHTML).join('');
        const pw = window.open('', '_blank');
        if (!pw) { window.print(); return; }
        pw.document.write(
            `<!DOCTYPE html><html><head><meta charset="UTF-8">` +
            `<style>*,*::before,*::after{box-sizing:border-box;}html{font-size:14px;}body{margin:0;padding:0;background:#fff;font-size:14px;}</style>` +
            `${inlineStyles}</head>` +
            `<body>${printContent.outerHTML}</body></html>`
        );
        pw.document.close();
        pw.addEventListener('load', () => { pw.print(); pw.close(); });
    };

    const candidates = data?.candidates || [];

    // Flask serialises dates as "Mon, 15 Sep 2025 00:00:00 GMT" — read with UTC getters so the day never shifts.
    const formatDate = (value) => {
        if (!value) return '';
        const d = new Date(value);
        if (isNaN(d.getTime())) return '';
        const dd = String(d.getUTCDate()).padStart(2, '0');
        const mm = String(d.getUTCMonth() + 1).padStart(2, '0');
        return `${dd}-${mm}-${d.getUTCFullYear()}`;
    };
    const attendanceDate = formatDate(candidates[0]?.training_atten_date);
    const trainingTitle = (data?.training_title_single || '').toUpperCase();

    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Training Attendance Sheet</h1>
                        </div>
                    </div>
                </div>
            </div>

            {/* ── FILTER SECTION (screen only) ── */}
            <div className="row mb-2 d-print-none">
                <div className="col-md-12">
                    <div className="card card-primary card-outline">
                        <div className="card-header">
                            <h5 className="card-title">
                                <i className="fas fa-filter mr-2"></i> Filter Records
                            </h5>
                        </div>
                        <div className="card-body">
                            <div className="form-row align-items-end">
                                <div className="form-group col-md-3"></div>
                                <div className="form-group col-md-3">
                                    <label>Batch Number</label>
                                    <select
                                        className="form-control select2"
                                        value={selectedBatchNo}
                                        onChange={handleBatchChange}
                                    >
                                        <option value="">Select a batch number</option>
                                        {batchNumbers.map((b) => (
                                            <option key={b.mas_id} value={b.batch_no}>{b.batch_no}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="form-group col-md-3 d-flex gap-2">
                                    <button className="btn btn-primary mr-2" onClick={handleViewButtonClick}>
                                        <i className="fas fa-eye mr-1"></i> View
                                    </button>
                                    <button className="btn btn-secondary" onClick={handleResetButtonClick}>
                                        <i className="fas fa-redo mr-1"></i> Reset
                                    </button>
                                </div>
                                <div className="form-group col-md-3"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <section className="content">
                <div className="container-fluid">
                    <div className="card">
                        <div className="card-body p-2">
                            <div className="printable-content">

                                {/* ══ HEADER ══ */}
                                <div className="page-header-top">
                                    <div className="header-text-left">
                                        <div className="company-name">EAZYWORLD EHS ENGINEERING PRIVATE LIMITED</div>
                                        <div className="iso-line">
                                            ISO 9001-2015 / 10002-2018 / 14001-2018 / 21001-2018 &amp; 45001-2018 CERTIFIED COMPANY
                                        </div>
                                    </div>
                                    <div className="header-logo-right">
                                        <img src="dist/img/eazylogo.png" alt="EWE Logo" className="logo-img" />
                                    </div>
                                </div>

                                <div className="header-titles">
                                    <div className="sheet-title">TRAINING ATTENDANCE SHEET</div>
                                    <div className="topic-line">
                                        TOPIC - &quot;{trainingTitle || 'SAFE OPERATION OF CRANES'}&quot;
                                    </div>
                                </div>

                                {/* ══ DATE & BATCH ══ */}
                                <div className="date-batch-row">
                                    <span>Date- {attendanceDate || '________________'}</span>
                                    <span>
                                        Batch No. -
                                        {selectedBatchNo ? `EWE-EHS-${selectedBatchNo}` : '________________'}

                                    </span>
                                </div>

                                {/* ══ CANDIDATES TABLE ══ */}
                                <table className="candidates-table">
                                    <thead>
                                        <tr>
                                            <th rowSpan={2} className="th-sl">SL</th>
                                            <th className="th-status">STATUS</th>
                                            <th className="th-name">CANDIDATE NAME</th>
                                            <th className="th-org">ORGANISATION</th>
                                            <th className="th-pf">PASS / FAIL</th>
                                            <th rowSpan={2} className="th-sign">CANDIDATE<br />SIGN</th>
                                        </tr>
                                        <tr>
                                            <th className="th-status">WORK LOCATION</th>
                                            <th className="th-name">DESIGNATION</th>
                                            <th className="th-org">SUB-CONTRACTOR</th>
                                            <th className="th-pf">
                                                CERTIFICATE<br />REFERENCE NUMBER<br />(CRN)
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {candidates.map((candidate, index) => {
                                            const isLast = index === candidates.length - 1;
                                            return (
                                                <React.Fragment key={candidate.mas_id}>
                                                    <tr className="row-top">
                                                        <td
                                                            rowSpan={2}
                                                            className={`td-c${isLast ? ' last-rowspan-cell' : ''}`}
                                                        >
                                                            {index + 1}
                                                        </td>
                                                        <td className="td-c td-b">{(candidate.reg_form || '').toUpperCase()}</td>
                                                        <td className="td-c td-b">{candidate.Name}</td>
                                                        <td className="td-c">{candidate.organization}</td>
                                                        <td className="td-c td-b">
                                                            <select
                                                                className="pf-select"
                                                                value={passFail[candidate.mas_id] ?? (candidate.evaluate_grade_status || '').toUpperCase()}
                                                                onChange={e => handlePassFailChange(candidate.mas_id, e.target.value)}
                                                            >
                                                                <option value="">— Select —</option>
                                                                <option value="PASS">PASS</option>
                                                                <option value="FAIL">FAIL</option>
                                                            </select>
                                                            <span className="pf-print">
                                                                {passFail[candidate.mas_id] ?? (candidate.evaluate_grade_status || '').toUpperCase()}
                                                            </span>
                                                        </td>
                                                        <td
                                                            rowSpan={2}
                                                            className={`td-sign-area${isLast ? ' last-rowspan-cell' : ''}`}
                                                        ></td>
                                                    </tr>
                                                    <tr className="row-bottom">
                                                        <td className="td-c">{(candidate.work_location || '').toUpperCase()}</td>
                                                        <td className="td-c">{candidate.designation}</td>
                                                        <td className="td-c">{candidate.sub_contractor}</td>
                                                        <td className="td-c td-crn">{candidate.sr_no}</td>
                                                    </tr>
                                                </React.Fragment>
                                            );
                                        })}
                                        {candidates.length === 0 && (
                                            <tr>
                                                <td colSpan={6} className="td-empty">
                                                    Select a batch number and click View to load candidates.
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>

                                {/* ══ FOOTER: Trainer | Seal | Coordinator — right after table ══ */}
                                <div className="footer-section">

                                    <div className="footer-trainer-block">
                                        <div className="trainer-sig-space"></div>
                                        <div className="footer-role-label">TRAINING ENGINEER</div>
                                    </div>

                                    <div className="footer-seal-block">
                                        <div className="seal-open-space"></div>
                                        <div className="seal-label-text">CERTIFIED SEAL</div>
                                    </div>

                                    <div className="footer-coord-block">
                                        <div className="d-none d-print-block coord-print-name">{formData.selectedCoordinator}</div>
                                        <div className="coord-sig-space"></div>
                                        <div className="footer-role-label">TRAINING CO-ORDINATOR</div>
                                    </div>

                                </div>

                                {/* ══ SPACER — pushes verification strip to page end ══ */}
                                <div className="print-spacer"></div>

                                {/* ══ VERIFICATION STRIP — pinned to bottom ══ */}
                                <div className="print-bottom-section">
                                    <div className="not-valid-line">Not valid unless sealed and signed.</div>
                                    <table className="verify-table">
                                        <tbody>
                                            <tr>
                                                <td className="vk">SIGN</td>
                                                <td></td><td></td><td></td><td></td><td></td><td></td>
                                            </tr>
                                            <tr>
                                                <td className="vk">DATE</td>
                                                <td></td><td></td><td></td><td></td><td></td><td></td>
                                            </tr>
                                            <tr>
                                                <td className="vk"></td>
                                                <td className="vh">SCAN COMPLETED</td>
                                                <td className="vh">COPIED FOR INVOICE</td>
                                                <td className="vh">EIR NOTED</td>
                                                <td className="vh">CERTIFICATE PROCESSED</td>
                                                <td className="vh">ID PROCESSED</td>
                                                <td className="vh">VERIFIED BY</td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    <div className="rev-note">
                                        REV – 07 Dated 30-01-2025 - BPD,'EWE-EHS/ATND/AMD/031D/2223 - PM 8HR to 031F/2425<br />
                                        Date -26-04-2022 Controlled copy - Approved By – Santhosh K
                                    </div>
                                </div>{/* /print-bottom-section */}

                            </div>{/* /printable-content */}

                            <div className="d-print-none text-center mt-4 mb-2">
                                <button className="btn btn-primary btn-lg" onClick={handlePrint}>
                                    <i className="fas fa-print mr-2"></i> Print Attendance Sheet
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <style>{`
/* ─── BASE ─── */
.printable-content {
    font-family: Arial, sans-serif;
    color: #000;
    background: #fff;
    max-width: 960px;
    margin: 0 auto;
    padding: 8px;
    display: flex;
    flex-direction: column;
    height: 297mm;
    box-sizing: border-box;
    overflow: visible;
}

/* ─── HEADER TOP ROW ─── */
.page-header-top {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 6px;
}
.header-text-left {
    flex: 1;
}
.company-name {
    font-size: 24px;
    font-weight: bold;
    line-height: 1.3;
    white-space: nowrap;
}
.iso-line {
    font-size: 12px;
    margin-top: 3px;
}
.header-logo-right {
    flex: 0 0 130px;
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;
}
.logo-img {
    width: 100px;
    height: 100px;
    object-fit: contain;
}

/* ─── HEADER TITLES ─── */
.header-titles {
    text-align: center;
    margin-bottom: 8px;
}
.sheet-title {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 2px;
}
.topic-line {
    font-size: 17px;
    font-weight: bold;
}

/* ─── DATE / BATCH ─── */
.date-batch-row {
    display: flex;
    justify-content: space-between;
    font-size: 18px;
    font-weight: bold;
    padding: 4px 2px 6px;
}

/* ─── CANDIDATES TABLE ─── */
.candidates-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
    flex-shrink: 0;
}
.candidates-table th,
.candidates-table td {
    border: 1px solid #000;
    padding: 7px 9px;
    vertical-align: middle;
}
.candidates-table thead th {
    background-color: #e8e8e8;
    text-align: center;
    font-size: 10px;
    font-weight: bold;
    line-height: 1.5;
}
.th-sl     { width: 36px;  text-align: center; }
.th-status { width: 115px; text-align: center; }
.th-name   { width: 155px; text-align: center; }
.th-org    { width: 215px; text-align: center; }
.th-pf     { width: 135px; text-align: center; }
.th-sign   { width: 145px; text-align: center; }

.td-sl        { text-align: center; font-weight: bold; font-size: 12px; }
.td-c         { text-align: center; }
.td-b         { font-weight: bold; }
.td-crn       { font-size: 10px; letter-spacing: 0.4px; }

.pf-select {
    border: 1px solid #aaa;
    padding: 3px 6px;
    font-size: 12px;
    font-weight: bold;
    text-align: center;
    width: 90px;
    cursor: pointer;
    background: #fff;
    border-radius: 3px;
}
.pf-print {
    display: none;
    font-weight: bold;
    font-size: 13px;
}
.td-sign-area { text-align: center; min-height: 60px; }
.td-empty     { text-align: center; padding: 20px; color: #999; font-style: italic; }

/* ─── ROW MERGING ─── */
.row-top td    { border-bottom: none !important; padding-bottom: 3px; }
.row-bottom td { border-top: 1px dashed #666 !important; padding-top: 3px; }

/* ─── LAST ROW FIX ─── */
.row-top td.last-rowspan-cell,
.candidates-table tbody tr.row-top td.last-rowspan-cell {
    border-bottom: 1px solid #000 !important;
}

/* ─── SPACER ─── */
.print-spacer {
    flex: 1 1 auto;
    min-height: 20px;
}

/* ─── BOTTOM SECTION ─── */
.print-bottom-section {
    flex-shrink: 0;
    position: static;
}

/* ─── FOOTER ─── */
.footer-section {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
    margin-top: 20px;
    margin-bottom: 10px;
    gap: 10px;
    flex-shrink: 0;
}
.footer-trainer-block {
    flex: 1;
    display: flex;
    flex-direction: column;
}
.trainer-sig-space {
    height: 80px;
}
.footer-role-label {
    font-size: 11px;
    font-weight: bold;
    padding-top: 4px;
    margin-top: 2px;
    letter-spacing: 0.5px;
}
.footer-trainer-block .footer-role-label {
    text-align: left;
}
.footer-coord-block .footer-role-label {
    text-align: right;
}
.footer-seal-block {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.seal-open-space {
    width: 120px;
    height: 120px;
}
.seal-label-text {
    font-size: 11px;
    font-weight: bold;
    text-align: center;
    letter-spacing: 0.5px;
    margin-top: 4px;
}
.footer-coord-block {
    flex: 1;
    display: flex;
    flex-direction: column;
}
.coord-print-name {
    font-size: 12px;
    font-weight: bold;
    text-align: right;
    margin-bottom: 4px;
}
.coord-sig-space {
    height: 80px;
}

/* ─── VERIFY STRIP ─── */
.not-valid-line {
    text-align: center;
    font-size: 11px;
    margin-bottom: 4px;
}
.verify-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 11px;
}
.verify-table td {
    border: 1px solid #000;
    padding: 5px 6px;
    text-align: center;
    height: 26px;
}
.vk { font-weight: bold; width: 55px; }
.vh { font-weight: bold; font-size: 10px; }

.rev-note {
    text-align: center;
    font-size: 9.5px;
    margin-top: 7px;
    color: #333;
    line-height: 1.6;
}

/* ─── PRINT ─── */
@media print {
    .pf-select { display: none !important; }
    .pf-print  { display: inline !important; }

    /* body is only .printable-content (replaced by handlePrint) */
    body {
        margin: 0 !important;
        padding: 0 !important;
        background: white !important;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
    }

    .printable-content {
        width: 100% !important;
        height: 297mm !important;
        padding: 8mm 10mm 0 !important;
        margin: 0 !important;
        display: flex !important;
        flex-direction: column !important;
        box-sizing: border-box !important;
        background: white !important;
    }

    /* spacer fills all space between table and footer */
    .print-spacer {
        flex: 1 1 auto !important;
    }

    /* footer pinned to very bottom — no gap */
    .print-bottom-section {
        flex-shrink: 0 !important;
        padding-bottom: 3mm !important;
    }

    .row-top td { border-bottom: none !important; }
    .row-top td.last-rowspan-cell,
    .candidates-table tbody tr.row-top td.last-rowspan-cell {
        border-bottom: 1px solid #000 !important;
    }
    .row-bottom td { border-top: 1px dashed #666 !important; }

    table { border-collapse: collapse !important; }
    td, th { word-wrap: break-word !important; vertical-align: middle !important; }

    .footer-section {
        display: flex !important;
        flex-direction: row !important;
        justify-content: space-between !important;
        align-items: flex-end !important;
        margin-top: 20px !important;
        margin-bottom: 10px !important;
        flex-shrink: 0 !important;
    }
    .footer-trainer-block { flex: 1 !important; }
    .footer-seal-block    { flex: 1 !important; }
    .footer-coord-block   { flex: 1 !important; }
    .seal-open-space {
        border: none !important;
        background: transparent !important;
    }
    .candidates-table thead th {
        background-color: #e8e8e8 !important;
    }

    @page {
        size: A4 portrait;
        margin: 0;
    }
}
            `}</style>
        </div>
    );
};

export default AttendanceSheet;